import { Label } from '@radix-ui/react-select';
import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './select.scss';

type Props = ComponentPropsWithoutRef<typeof Label>;
export const SelectLabel = ({ className, ...props }: Props) => {
    return <Label data-testid="select-label" className={cn('select__label', className)} {...props} />;
};
